<template>
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path fill="currentColor"
            d="M13.5 2.2c.4 3.1-1.3 4.5-2.8 6.1-1.1 1.2-2.1 2.4-1.8 4.2.1.7.5 1.3 1.1 1.8-.1-1.8.8-3.2 2.1-4.5.2 2.2 1.6 3.3 2.7 4.5.8.9 1.3 1.8 1.2 3.1 1.2-1 2-2.5 2-4.2 0-2.9-1.6-5.5-4.5-11zM8.4 9.1C5.5 11.5 4 14 4 16.5A7.5 7.5 0 0 0 11.5 24a7.5 7.5 0 0 0 7.5-7.5c0-.7-.1-1.4-.3-2-1 3.5-3 4.7-4.7 5.2.5-1.2.2-2.5-.8-3.6-.6-.7-1.3-1.3-1.8-2.1-.4 1.2-.3 2.3.2 3.4-2-.4-4.4-2.4-3.2-8.3z" />
    </svg>
</template>

<style scoped>
svg {
    display: block;
    width: 1em;
    height: 1em;
}
</style>
